import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=6640807a"
import script from "./AreaChart.vue?vue&type=script&lang=ts"
export * from "./AreaChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports